export default "__VITE_ASSET__DB9nFBKx__"